import Form from "./Form";

export default class NavigationItem
{
	constructor(el)
	{
		this.el = el;
	}

	static className = () => "diary-day-search-edibles-navigation__item";
	static selector = () => `.${this.className()}`;
	static activeClassName = () => `${this.className()}--active`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()}, ${this.selector()} *`)) {
				event.preventDefault();
				(new this(event.target.closest(this.selector()))).navigate();
			}
		});
	}

	getForm()
	{
		return new Form(this.el.closest(Form.selector()));
	}

	getAffix()
	{
		return this.el.dataset.affix;
	}

	getCategory()
	{
		return this.el.dataset?.category;
	}

	setTotal(total)
	{
		this.el.querySelector(`.diary-day-search-edibles-form__category-total`).innerHTML = total;
		total ? this.show() : this.hide();
	}

	select()
	{
		this.el.classList.add(NavigationItem.activeClassName());

		return this;
	}

	unselect()
	{
		this.el.classList.remove(NavigationItem.activeClassName());

		return this;
	}

	hide()
	{
		this.el.hidden = true;

		return this;
	}

	show()
	{
		this.el.hidden = false;

		return this;
	}

	setFromQueryResponse(response)
	{
		if (this.getCategory()) {
			this.setTotal(response.data.categories[this.getCategory()]?.pagination.total);
		}
	}

	navigate()
	{
		(this.getAffix() == "category") ? this.getForm().showCategory(this.getCategory()) : this.getForm().showOverview();
	}
}
